import { render, staticRenderFns } from "./SampleSet.vue?vue&type=template&id=4712b771&scoped=true"
import script from "./SampleSet.vue?vue&type=script&lang=js"
export * from "./SampleSet.vue?vue&type=script&lang=js"
import style0 from "./SampleSet.vue?vue&type=style&index=0&id=4712b771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712b771",
  null
  
)

export default component.exports